import { SubscriptionFrequency } from 'lib/home/generated/types/api';

export const GATSBY_NODE_ENV = process.env.NODE_ENV;

export const STOREFRONT_URL = process.env.GATSBY_STOREFRONT_URL;

export const API_URL = process.env.GATSBY_STOREFRONT_API_URL;

export const GRAPHQL_URL = process.env.GATSBY_STOREFRONT_GRAPHQL_URL;

export const STRIPE_PUBLIC_KEY = process.env.GATSBY_STRIPE_PUBLIC_KEY;

export const OPEN_REPLAY_PROJECT = process.env.GATSBY_OPEN_REPLAY_PROJECT;

export const HUBSPOT_PORTAL_ID = process.env.GATSBY_HUBSPOT_PORTAL_ID;

export const siteURL = (path: string): string => `${STOREFRONT_URL}${path}`;

export const googleAuthURL = (redirect: string) => `${process.env.GATSBY_OAUTH_GOOGLE_REDIRECT_URL}?state=${redirect}`;

export const facebookAuthURL = (redirect: string) =>
  `${process.env.GATSBY_OAUTH_FACEBOOK_REDIRECT_URL}?state=${redirect}`;

// Subscriptions
export const SUBSCRIPTION_FREQUENCIES = {
  [SubscriptionFrequency.TwoWeeks]: 'two',
  [SubscriptionFrequency.ThreeWeeks]: 'three',
  [SubscriptionFrequency.FourWeeks]: 'four'
};
